import { render, staticRenderFns } from "./AdminStat.vue?vue&type=template&id=381c995e&scoped=true&"
import script from "./AdminStat.vue?vue&type=script&lang=js&"
export * from "./AdminStat.vue?vue&type=script&lang=js&"
import style0 from "./AdminStat.vue?vue&type=style&index=0&id=381c995e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c995e",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QPageContainer,QSelect,QBtn,QToggle});
